import { z } from "../wire/zod";

export const addShapeResponseSchema = z.object({ id: z.string() });
export const addStickyToIterationResponseSchema = z.object({ id: z.string().optional() });
export const boardScaledEventSchema = z.number();
export const createStickyOnRiskBoardResponseSchema = z.object({ id: z.string() });
export const createStickyResponseSchema = z.object({ id: z.string() });
export const getBoardStateResponseSchema = z.object({
  results: z.array(
    z.object({
      id: z.string(),
      almIssueId: z.union([z.number().int(), z.string()]).optional(),
      boardId: z.string(),
      WSJFValue: z.union([z.number(), z.null()]).optional(),
      almIssueUrl: z.string().optional(),
      stackPos: z.number().int().optional(),
      text: z.string().optional(),
      typeId: z.string(),
      statusClass: z.enum(["todo", "in-progress", "done", "undefined"]).optional(),
      status: z.string().optional(),
      aCenter: z.tuple([z.number(), z.number()]).optional(),
      teamId: z.union([z.number().int(), z.null()]).optional(),
      iterationNumber: z.union([z.number().int(), z.null()]).optional(),
      almSource: z.union([z.number().int(), z.string(), z.null()]).optional(),
      storyPoints: z.union([z.number(), z.null()]).optional(),
      risk: z.enum(["R", "O", "A", "M", ""]).optional(),
      dependTeamId: z.union([z.number().int(), z.null()]).optional(),
      dependTeam: z.union([z.string(), z.null()]).optional(),
      objectives: z.array(z.object({ id: z.string(), boardId: z.string() })).optional(),
      precondTeamId: z.number().int().optional(),
      precondTeam: z.string().optional(),
      flagType: z.union([z.string(), z.null()]).optional(),
      stickyGroup: z.union([z.string(), z.null()]).optional(),
      artId: z.union([z.number().int(), z.null()]).optional(),
      transition: z.string().optional(),
      reactions: z.record(z.string(), z.array(z.string())).optional(),
      assignee: z
        .union([
          z.object({
            pipId: z
              .union([
                z.string().describe("PI planning user id, null when the user is not mapped"),
                z.null().describe("PI planning user id, null when the user is not mapped"),
              ])
              .describe("PI planning user id, null when the user is not mapped"),
            almId: z
              .union([
                z.string().describe("ALM user id, null when the user is not a mapped ALM user"),
                z.null().describe("ALM user id, null when the user is not a mapped ALM user"),
              ])
              .describe("ALM user id, null when the user is not a mapped ALM user"),
          }),
          z.null(),
        ])
        .optional(),
      reporter: z
        .union([
          z.object({
            pipId: z
              .union([
                z.string().describe("PI planning user id, null when the user is not mapped"),
                z.null().describe("PI planning user id, null when the user is not mapped"),
              ])
              .describe("PI planning user id, null when the user is not mapped"),
            almId: z
              .union([
                z.string().describe("ALM user id, null when the user is not a mapped ALM user"),
                z.null().describe("ALM user id, null when the user is not a mapped ALM user"),
              ])
              .describe("ALM user id, null when the user is not a mapped ALM user"),
          }),
          z.null(),
        ])
        .optional(),
      stepValue: z
        .union([
          z
            .number()
            .int()
            .describe(
              "Id of the sticky's step estimate, one of the type's step_estimate_values; null when it has none",
            ),
          z
            .null()
            .describe(
              "Id of the sticky's step estimate, one of the type's step_estimate_values; null when it has none",
            ),
        ])
        .describe(
          "Id of the sticky's step estimate, one of the type's step_estimate_values; null when it has none",
        )
        .optional(),
      templateId: z.string().optional(),
      isOrigin: z.boolean().optional(),
      linkedStickies: z
        .array(
          z.object({ linkId: z.string(), stickyId: z.string(), direction: z.enum(["from", "to"]) }),
        )
        .optional(),
      statusDistribution: z
        .union([
          z
            .record(z.string(), z.object({ points: z.number(), value: z.number().int() }))
            .describe("Progress of the linked child stickies by status class"),
          z.null(),
        ])
        .optional(),
      statusDistributionState: z
        .union([
          z
            .enum(["ready", "pending", "unavailable"])
            .describe(
              "ready: the graph result is present. pending: the graph is still being built; the result will follow. unavailable: the graph could not be read.",
            ),
          z.null(),
        ])
        .optional(),
    }),
  ),
});
export const getDiffResponseSchema = z
  .object({
    results: z.array(
      z.union([
        z.object({
          kind: z.literal("create"),
          stickyId: z.string(),
          timestamp: z.number().int(),
          userId: z.string(),
        }),
        z.object({
          kind: z.literal("update"),
          stickyId: z.string(),
          timestamp: z.number().int(),
          userId: z.string(),
          changes: z.array(
            z
              .object({ key: z.string(), old: z.any().optional(), new: z.any().optional() })
              .describe(
                "One changed sticky field; old/new carry the field's raw value (any JSON type)",
              ),
          ),
        }),
        z.object({
          kind: z.literal("delete"),
          stickyId: z.string(),
          timestamp: z.number().int(),
          userId: z.string(),
          changes: z.array(
            z
              .object({ key: z.string(), old: z.any().optional(), new: z.any().optional() })
              .describe(
                "One changed sticky field; old/new carry the field's raw value (any JSON type)",
              ),
          ),
        }),
        z.object({
          kind: z.literal("mirror"),
          stickyId: z.string(),
          timestamp: z.number().int(),
          userId: z.string(),
          fromBoard: z.string(),
          toBoard: z.string(),
        }),
        z.object({
          kind: z.literal("unmirror"),
          stickyId: z.string(),
          timestamp: z.number().int(),
          userId: z.string(),
          fromBoard: z.string(),
          toBoard: z.string(),
        }),
        z.object({
          kind: z.literal("link"),
          stickyId: z.string(),
          timestamp: z.number().int(),
          userId: z.string(),
          linkedTo: z.string(),
        }),
        z.object({
          kind: z.literal("unlink"),
          stickyId: z.string(),
          timestamp: z.number().int(),
          userId: z.string(),
          linkedTo: z.string(),
        }),
      ]),
    ),
    limit: z.number().int(),
    total: z.number().int(),
    offset: z
      .union([
        z
          .number()
          .int()
          .describe("Always null today; server responses exclude_none, so the key may be absent"),
        z
          .null()
          .describe("Always null today; server responses exclude_none, so the key may be absent"),
      ])
      .describe("Always null today; server responses exclude_none, so the key may be absent")
      .optional(),
  })
  .describe(
    "Paginated change list; mirrors piserver EventLogResponse (last `limit` of `total` changes)",
  );
export const getEventLogResponseSchema = z
  .object({
    results: z.array(
      z.union([
        z.object({
          kind: z.literal("create"),
          stickyId: z.string(),
          timestamp: z.number().int(),
          userId: z.string(),
        }),
        z.object({
          kind: z.literal("update"),
          stickyId: z.string(),
          timestamp: z.number().int(),
          userId: z.string(),
          changes: z.array(
            z
              .object({ key: z.string(), old: z.any().optional(), new: z.any().optional() })
              .describe(
                "One changed sticky field; old/new carry the field's raw value (any JSON type)",
              ),
          ),
        }),
        z.object({
          kind: z.literal("delete"),
          stickyId: z.string(),
          timestamp: z.number().int(),
          userId: z.string(),
          changes: z.array(
            z
              .object({ key: z.string(), old: z.any().optional(), new: z.any().optional() })
              .describe(
                "One changed sticky field; old/new carry the field's raw value (any JSON type)",
              ),
          ),
        }),
        z.object({
          kind: z.literal("mirror"),
          stickyId: z.string(),
          timestamp: z.number().int(),
          userId: z.string(),
          fromBoard: z.string(),
          toBoard: z.string(),
        }),
        z.object({
          kind: z.literal("unmirror"),
          stickyId: z.string(),
          timestamp: z.number().int(),
          userId: z.string(),
          fromBoard: z.string(),
          toBoard: z.string(),
        }),
        z.object({
          kind: z.literal("link"),
          stickyId: z.string(),
          timestamp: z.number().int(),
          userId: z.string(),
          linkedTo: z.string(),
        }),
        z.object({
          kind: z.literal("unlink"),
          stickyId: z.string(),
          timestamp: z.number().int(),
          userId: z.string(),
          linkedTo: z.string(),
        }),
      ]),
    ),
    limit: z.number().int(),
    total: z.number().int(),
    offset: z
      .union([
        z
          .number()
          .int()
          .describe("Always null today; server responses exclude_none, so the key may be absent"),
        z
          .null()
          .describe("Always null today; server responses exclude_none, so the key may be absent"),
      ])
      .describe("Always null today; server responses exclude_none, so the key may be absent")
      .optional(),
  })
  .describe(
    "Paginated change list; mirrors piserver EventLogResponse (last `limit` of `total` changes)",
  );
export const getIterationsResponseSchema = z.object({
  iterations: z.array(
    z.object({
      boardIterationId: z.number().int(),
      velocity: z.union([z.number(), z.string()]),
      statusDistribution: z
        .record(z.string(), z.object({ points: z.number(), value: z.number().int() }))
        .describe("Progress of the linked child stickies by status class")
        .optional(),
    }),
  ),
});
export const getObjectivesResponseSchema = z.object({
  objectives: z.array(
    z
      .object({
        id: z.string(),
        text: z.string(),
        description: z.string().optional(),
        bv: z.number().int().describe("Business value; absent until someone sets it").optional(),
        av: z
          .union([
            z.number().int().describe("Actual value; null until set"),
            z.null().describe("Actual value; null until set"),
          ])
          .describe("Actual value; null until set")
          .optional(),
        rag: z.enum(["red", "amber", "green"]),
        stickies: z.array(z.object({ id: z.string(), isOrigin: z.boolean() })).optional(),
        linkedObjectives: z.array(z.object({ id: z.string(), boardId: z.string() })).optional(),
        stickyTree: z
          .object({
            stickies: z.array(z.object({ id: z.string(), children: z.array(z.any()) })),
            statusDistribution: z
              .record(z.string(), z.object({ points: z.number(), value: z.number().int() }))
              .describe("Progress of the linked child stickies by status class"),
            statusDistributionState: z
              .enum(["ready", "pending", "unavailable"])
              .describe(
                "ready: the graph result is present. pending: the graph is still being built; the result will follow. unavailable: the graph could not be read.",
              )
              .optional(),
          })
          .describe(
            "An objective's sticky hierarchy with its status roll-up; only present on enriched requests",
          )
          .optional(),
      })
      .describe(
        "A board objective as objectives.get returns it; stretch objectives use the same shape and are listed separately",
      ),
  ),
  stretches: z.array(
    z
      .object({
        id: z.string(),
        text: z.string(),
        description: z.string().optional(),
        bv: z.number().int().describe("Business value; absent until someone sets it").optional(),
        av: z
          .union([
            z.number().int().describe("Actual value; null until set"),
            z.null().describe("Actual value; null until set"),
          ])
          .describe("Actual value; null until set")
          .optional(),
        rag: z.enum(["red", "amber", "green"]),
        stickies: z.array(z.object({ id: z.string(), isOrigin: z.boolean() })).optional(),
        linkedObjectives: z.array(z.object({ id: z.string(), boardId: z.string() })).optional(),
        stickyTree: z
          .object({
            stickies: z.array(z.object({ id: z.string(), children: z.array(z.any()) })),
            statusDistribution: z
              .record(z.string(), z.object({ points: z.number(), value: z.number().int() }))
              .describe("Progress of the linked child stickies by status class"),
            statusDistributionState: z
              .enum(["ready", "pending", "unavailable"])
              .describe(
                "ready: the graph result is present. pending: the graph is still being built; the result will follow. unavailable: the graph could not be read.",
              )
              .optional(),
          })
          .describe(
            "An objective's sticky hierarchy with its status roll-up; only present on enriched requests",
          )
          .optional(),
      })
      .describe(
        "A board objective as objectives.get returns it; stretch objectives use the same shape and are listed separately",
      ),
  ),
});
export const getSignalsResponseSchema = z
  .object({
    state: z
      .enum(["ready", "pending", "unavailable"])
      .describe(
        "ready: the graph result is present. pending: the graph is still being built; the result will follow. unavailable: the graph could not be read.",
      ),
    unplannedDependencies: z
      .array(z.string())
      .describe(
        "Dependencies on the board with no planned work by the enabling team. Dependencies whose enabling team has no team board (external) are skipped",
      ),
    noUpperLevelLink: z
      .array(z.string())
      .describe("Team Work Items on the board with no path to an upper-level Work Item"),
    noObjective: z
      .array(z.string())
      .describe("Team Work Items on the board with no hierarchy path to an objective"),
    notOnArtBoard: z
      .array(z.string())
      .describe("Dependencies on the board with no placement on an ART planning board"),
  })
  .describe(
    "Graph-derived signals of one board. Each list holds the ids of the stickies the signal flags; a mirror is reported by its origin's id.",
  );
export const getStickiesResponseSchema = z
  .object({
    stickies: z
      .array(
        z.object({
          id: z.string(),
          almIssueId: z.union([z.number().int(), z.string()]).optional(),
          boardId: z.string(),
          WSJFValue: z.union([z.number(), z.null()]).optional(),
          almIssueUrl: z.string().optional(),
          stackPos: z.number().int().optional(),
          text: z.string().optional(),
          typeId: z.string(),
          statusClass: z.enum(["todo", "in-progress", "done", "undefined"]).optional(),
          status: z.string().optional(),
          aCenter: z.tuple([z.number(), z.number()]).optional(),
          teamId: z.union([z.number().int(), z.null()]).optional(),
          iterationNumber: z.union([z.number().int(), z.null()]).optional(),
          almSource: z.union([z.number().int(), z.string(), z.null()]).optional(),
          storyPoints: z.union([z.number(), z.null()]).optional(),
          risk: z.enum(["R", "O", "A", "M", ""]).optional(),
          dependTeamId: z.union([z.number().int(), z.null()]).optional(),
          dependTeam: z.union([z.string(), z.null()]).optional(),
          objectives: z.array(z.object({ id: z.string(), boardId: z.string() })).optional(),
          precondTeamId: z.number().int().optional(),
          precondTeam: z.string().optional(),
          flagType: z.union([z.string(), z.null()]).optional(),
          stickyGroup: z.union([z.string(), z.null()]).optional(),
          artId: z.union([z.number().int(), z.null()]).optional(),
          transition: z.string().optional(),
          reactions: z.record(z.string(), z.array(z.string())).optional(),
          assignee: z
            .union([
              z.object({
                pipId: z
                  .union([
                    z.string().describe("PI planning user id, null when the user is not mapped"),
                    z.null().describe("PI planning user id, null when the user is not mapped"),
                  ])
                  .describe("PI planning user id, null when the user is not mapped"),
                almId: z
                  .union([
                    z.string().describe("ALM user id, null when the user is not a mapped ALM user"),
                    z.null().describe("ALM user id, null when the user is not a mapped ALM user"),
                  ])
                  .describe("ALM user id, null when the user is not a mapped ALM user"),
              }),
              z.null(),
            ])
            .optional(),
          reporter: z
            .union([
              z.object({
                pipId: z
                  .union([
                    z.string().describe("PI planning user id, null when the user is not mapped"),
                    z.null().describe("PI planning user id, null when the user is not mapped"),
                  ])
                  .describe("PI planning user id, null when the user is not mapped"),
                almId: z
                  .union([
                    z.string().describe("ALM user id, null when the user is not a mapped ALM user"),
                    z.null().describe("ALM user id, null when the user is not a mapped ALM user"),
                  ])
                  .describe("ALM user id, null when the user is not a mapped ALM user"),
              }),
              z.null(),
            ])
            .optional(),
          stepValue: z
            .union([
              z
                .number()
                .int()
                .describe(
                  "Id of the sticky's step estimate, one of the type's step_estimate_values; null when it has none",
                ),
              z
                .null()
                .describe(
                  "Id of the sticky's step estimate, one of the type's step_estimate_values; null when it has none",
                ),
            ])
            .describe(
              "Id of the sticky's step estimate, one of the type's step_estimate_values; null when it has none",
            )
            .optional(),
          templateId: z.string().optional(),
          isOrigin: z.boolean().optional(),
          linkedStickies: z
            .array(
              z.object({
                linkId: z.string(),
                stickyId: z.string(),
                direction: z.enum(["from", "to"]),
              }),
            )
            .optional(),
          statusDistribution: z
            .union([
              z
                .record(z.string(), z.object({ points: z.number(), value: z.number().int() }))
                .describe("Progress of the linked child stickies by status class"),
              z.null(),
            ])
            .optional(),
          statusDistributionState: z
            .union([
              z
                .enum(["ready", "pending", "unavailable"])
                .describe(
                  "ready: the graph result is present. pending: the graph is still being built; the result will follow. unavailable: the graph could not be read.",
                ),
              z.null(),
            ])
            .optional(),
        }),
      )
      .optional(),
    updates: z
      .array(
        z
          .object({
            event: z.enum(["add_sticky", "alter_sticky", "delete_sticky"]),
            obj: z
              .object({
                id: z.string().optional(),
                almIssueId: z.union([z.number().int(), z.string()]).optional(),
                boardId: z.string().optional(),
                WSJFValue: z.union([z.number(), z.null()]).optional(),
                almIssueUrl: z.string().optional(),
                stackPos: z.number().int().optional(),
                text: z.string().optional(),
                typeId: z.string().optional(),
                statusClass: z.enum(["todo", "in-progress", "done", "undefined"]).optional(),
                status: z.string().optional(),
                aCenter: z.tuple([z.number(), z.number()]).optional(),
                teamId: z.union([z.number().int(), z.null()]).optional(),
                iterationNumber: z.union([z.number().int(), z.null()]).optional(),
                almSource: z.union([z.number().int(), z.string(), z.null()]).optional(),
                storyPoints: z.union([z.number(), z.null()]).optional(),
                risk: z.enum(["R", "O", "A", "M", ""]).optional(),
                dependTeamId: z.union([z.number().int(), z.null()]).optional(),
                dependTeam: z.union([z.string(), z.null()]).optional(),
                objectives: z.array(z.object({ id: z.string(), boardId: z.string() })).optional(),
                precondTeamId: z.number().int().optional(),
                precondTeam: z.string().optional(),
                flagType: z.union([z.string(), z.null()]).optional(),
                stickyGroup: z.union([z.string(), z.null()]).optional(),
                artId: z.union([z.number().int(), z.null()]).optional(),
                transition: z.string().optional(),
                reactions: z.record(z.string(), z.array(z.string())).optional(),
                assignee: z
                  .union([
                    z.object({
                      pipId: z
                        .union([
                          z
                            .string()
                            .describe("PI planning user id, null when the user is not mapped"),
                          z
                            .null()
                            .describe("PI planning user id, null when the user is not mapped"),
                        ])
                        .describe("PI planning user id, null when the user is not mapped"),
                      almId: z
                        .union([
                          z
                            .string()
                            .describe("ALM user id, null when the user is not a mapped ALM user"),
                          z
                            .null()
                            .describe("ALM user id, null when the user is not a mapped ALM user"),
                        ])
                        .describe("ALM user id, null when the user is not a mapped ALM user"),
                    }),
                    z.null(),
                  ])
                  .optional(),
                reporter: z
                  .union([
                    z.object({
                      pipId: z
                        .union([
                          z
                            .string()
                            .describe("PI planning user id, null when the user is not mapped"),
                          z
                            .null()
                            .describe("PI planning user id, null when the user is not mapped"),
                        ])
                        .describe("PI planning user id, null when the user is not mapped"),
                      almId: z
                        .union([
                          z
                            .string()
                            .describe("ALM user id, null when the user is not a mapped ALM user"),
                          z
                            .null()
                            .describe("ALM user id, null when the user is not a mapped ALM user"),
                        ])
                        .describe("ALM user id, null when the user is not a mapped ALM user"),
                    }),
                    z.null(),
                  ])
                  .optional(),
                stepValue: z
                  .union([
                    z
                      .number()
                      .int()
                      .describe(
                        "Id of the sticky's step estimate, one of the type's step_estimate_values; null when it has none",
                      ),
                    z
                      .null()
                      .describe(
                        "Id of the sticky's step estimate, one of the type's step_estimate_values; null when it has none",
                      ),
                  ])
                  .describe(
                    "Id of the sticky's step estimate, one of the type's step_estimate_values; null when it has none",
                  )
                  .optional(),
                templateId: z.string().optional(),
                isOrigin: z.boolean().optional(),
                linkedStickies: z
                  .array(
                    z.object({
                      linkId: z.string(),
                      stickyId: z.string(),
                      direction: z.enum(["from", "to"]),
                    }),
                  )
                  .optional(),
                statusDistribution: z
                  .union([
                    z
                      .record(z.string(), z.object({ points: z.number(), value: z.number().int() }))
                      .describe("Progress of the linked child stickies by status class"),
                    z.null(),
                  ])
                  .optional(),
                statusDistributionState: z
                  .union([
                    z
                      .enum(["ready", "pending", "unavailable"])
                      .describe(
                        "ready: the graph result is present. pending: the graph is still being built; the result will follow. unavailable: the graph could not be read.",
                      ),
                    z.null(),
                  ])
                  .optional(),
              })
              .describe("Update payload: a missing key leaves the field unchanged."),
          })
          .describe(
            "A change on the board since the requested timestamp. obj carries the changed fields and always the id; a delete carries only the id",
          ),
      )
      .optional(),
    timestamp: z
      .number()
      .int()
      .describe("Epoch ms of this fetch; pass it back as GetStickiesRequest.timestamp")
      .optional(),
  })
  .describe(
    "A plain request answers with the stickies alone. A delta request answers with updates since the timestamp (cache hit) or falls back to the full stickies list (cache miss), stamped with the fetch timestamp for the next delta.",
  );
export const getStickyScaleResponseSchema = z.object({ scale: z.number() });
export const iterationUpdatedEventSchema = z.object({
  boardIterationId: z.number().int(),
  velocity: z.union([z.number(), z.string()]),
  statusDistribution: z
    .record(z.string(), z.object({ points: z.number(), value: z.number().int() }))
    .describe("Progress of the linked child stickies by status class")
    .optional(),
});
export const mirrorStickyResponseSchema = z.object({
  mirroredId: z
    .string()
    .describe("Id of the sticky on the target board; absent when it already existed there")
    .optional(),
  created: z.boolean(),
});
export const noDataSchema = z.record(z.string(), z.never());
export const objectiveCreatedEventSchema = z.object({
  text: z.string(),
  description: z.string(),
  isStretch: z.boolean(),
});
export const objectiveUpdatedEventSchema = z
  .object({
    objective: z
      .object({
        text: z.string().optional(),
        description: z.string().optional(),
        bv: z.number().int().optional(),
        av: z.union([z.number().int(), z.null()]).optional(),
        rag: z.enum(["red", "amber", "green"]).optional(),
        stickies: z.array(z.object({ id: z.string(), isOrigin: z.boolean() })).optional(),
        linkedObjectives: z.array(z.object({ id: z.string(), boardId: z.string() })).optional(),
        stickyTree: z
          .object({
            stickies: z.array(z.object({ id: z.string(), children: z.array(z.any()) })),
            statusDistribution: z
              .record(z.string(), z.object({ points: z.number(), value: z.number().int() }))
              .describe("Progress of the linked child stickies by status class"),
            statusDistributionState: z
              .enum(["ready", "pending", "unavailable"])
              .describe(
                "ready: the graph result is present. pending: the graph is still being built; the result will follow. unavailable: the graph could not be read.",
              )
              .optional(),
          })
          .describe(
            "An objective's sticky hierarchy with its status roll-up; only present on enriched requests",
          )
          .optional(),
      })
      .describe("Update payload: a missing key leaves the field unchanged.")
      .optional(),
    place: z.object({ isStretch: z.boolean(), position: z.number().int() }).optional(),
  })
  .describe("Update payload: a missing key leaves the field unchanged.");
export const shapeCreatedEventSchema = z.object({
  id: z.string(),
  type: z.literal("line"),
  fixed: z.boolean(),
  p0: z.object({ x: z.number(), y: z.number() }),
  p1: z.object({ x: z.number(), y: z.number() }),
  label: z
    .union([z.object({ text: z.string(), align: z.enum(["start", "center", "end"]) }), z.null()])
    .optional(),
});
export const shapeDeletedEventSchema = z.string();
export const shapeUpdatedEventSchema = z.object({
  id: z.string(),
  type: z.literal("line"),
  fixed: z.boolean(),
  p0: z.object({ x: z.number(), y: z.number() }),
  p1: z.object({ x: z.number(), y: z.number() }),
  label: z
    .union([z.object({ text: z.string(), align: z.enum(["start", "center", "end"]) }), z.null()])
    .optional(),
});
export const stickyCreatedEventSchema = z.object({
  id: z.string(),
  almIssueId: z.union([z.number().int(), z.string()]).optional(),
  boardId: z.string(),
  WSJFValue: z.union([z.number(), z.null()]).optional(),
  almIssueUrl: z.string().optional(),
  stackPos: z.number().int().optional(),
  text: z.string().optional(),
  typeId: z.string(),
  statusClass: z.enum(["todo", "in-progress", "done", "undefined"]).optional(),
  status: z.string().optional(),
  aCenter: z.tuple([z.number(), z.number()]).optional(),
  teamId: z.union([z.number().int(), z.null()]).optional(),
  iterationNumber: z.union([z.number().int(), z.null()]).optional(),
  almSource: z.union([z.number().int(), z.string(), z.null()]).optional(),
  storyPoints: z.union([z.number(), z.null()]).optional(),
  risk: z.enum(["R", "O", "A", "M", ""]).optional(),
  dependTeamId: z.union([z.number().int(), z.null()]).optional(),
  dependTeam: z.union([z.string(), z.null()]).optional(),
  objectives: z.array(z.object({ id: z.string(), boardId: z.string() })).optional(),
  precondTeamId: z.number().int().optional(),
  precondTeam: z.string().optional(),
  flagType: z.union([z.string(), z.null()]).optional(),
  stickyGroup: z.union([z.string(), z.null()]).optional(),
  artId: z.union([z.number().int(), z.null()]).optional(),
  transition: z.string().optional(),
  reactions: z.record(z.string(), z.array(z.string())).optional(),
  assignee: z
    .union([
      z.object({
        pipId: z
          .union([
            z.string().describe("PI planning user id, null when the user is not mapped"),
            z.null().describe("PI planning user id, null when the user is not mapped"),
          ])
          .describe("PI planning user id, null when the user is not mapped"),
        almId: z
          .union([
            z.string().describe("ALM user id, null when the user is not a mapped ALM user"),
            z.null().describe("ALM user id, null when the user is not a mapped ALM user"),
          ])
          .describe("ALM user id, null when the user is not a mapped ALM user"),
      }),
      z.null(),
    ])
    .optional(),
  reporter: z
    .union([
      z.object({
        pipId: z
          .union([
            z.string().describe("PI planning user id, null when the user is not mapped"),
            z.null().describe("PI planning user id, null when the user is not mapped"),
          ])
          .describe("PI planning user id, null when the user is not mapped"),
        almId: z
          .union([
            z.string().describe("ALM user id, null when the user is not a mapped ALM user"),
            z.null().describe("ALM user id, null when the user is not a mapped ALM user"),
          ])
          .describe("ALM user id, null when the user is not a mapped ALM user"),
      }),
      z.null(),
    ])
    .optional(),
  stepValue: z
    .union([
      z
        .number()
        .int()
        .describe(
          "Id of the sticky's step estimate, one of the type's step_estimate_values; null when it has none",
        ),
      z
        .null()
        .describe(
          "Id of the sticky's step estimate, one of the type's step_estimate_values; null when it has none",
        ),
    ])
    .describe(
      "Id of the sticky's step estimate, one of the type's step_estimate_values; null when it has none",
    )
    .optional(),
  templateId: z.string().optional(),
  isOrigin: z.boolean().optional(),
  linkedStickies: z
    .array(
      z.object({ linkId: z.string(), stickyId: z.string(), direction: z.enum(["from", "to"]) }),
    )
    .optional(),
  statusDistribution: z
    .union([
      z
        .record(z.string(), z.object({ points: z.number(), value: z.number().int() }))
        .describe("Progress of the linked child stickies by status class"),
      z.null(),
    ])
    .optional(),
  statusDistributionState: z
    .union([
      z
        .enum(["ready", "pending", "unavailable"])
        .describe(
          "ready: the graph result is present. pending: the graph is still being built; the result will follow. unavailable: the graph could not be read.",
        ),
      z.null(),
    ])
    .optional(),
});
export const stickyUpdateEndedEventSchema = z
  .object({
    id: z.string().optional(),
    almIssueId: z.union([z.number().int(), z.string()]).optional(),
    boardId: z.string().optional(),
    WSJFValue: z.union([z.number(), z.null()]).optional(),
    almIssueUrl: z.string().optional(),
    stackPos: z.number().int().optional(),
    text: z.string().optional(),
    typeId: z.string().optional(),
    statusClass: z.enum(["todo", "in-progress", "done", "undefined"]).optional(),
    status: z.string().optional(),
    aCenter: z.tuple([z.number(), z.number()]).optional(),
    teamId: z.union([z.number().int(), z.null()]).optional(),
    iterationNumber: z.union([z.number().int(), z.null()]).optional(),
    almSource: z.union([z.number().int(), z.string(), z.null()]).optional(),
    storyPoints: z.union([z.number(), z.null()]).optional(),
    risk: z.enum(["R", "O", "A", "M", ""]).optional(),
    dependTeamId: z.union([z.number().int(), z.null()]).optional(),
    dependTeam: z.union([z.string(), z.null()]).optional(),
    objectives: z.array(z.object({ id: z.string(), boardId: z.string() })).optional(),
    precondTeamId: z.number().int().optional(),
    precondTeam: z.string().optional(),
    flagType: z.union([z.string(), z.null()]).optional(),
    stickyGroup: z.union([z.string(), z.null()]).optional(),
    artId: z.union([z.number().int(), z.null()]).optional(),
    transition: z.string().optional(),
    reactions: z.record(z.string(), z.array(z.string())).optional(),
    assignee: z
      .union([
        z.object({
          pipId: z
            .union([
              z.string().describe("PI planning user id, null when the user is not mapped"),
              z.null().describe("PI planning user id, null when the user is not mapped"),
            ])
            .describe("PI planning user id, null when the user is not mapped"),
          almId: z
            .union([
              z.string().describe("ALM user id, null when the user is not a mapped ALM user"),
              z.null().describe("ALM user id, null when the user is not a mapped ALM user"),
            ])
            .describe("ALM user id, null when the user is not a mapped ALM user"),
        }),
        z.null(),
      ])
      .optional(),
    reporter: z
      .union([
        z.object({
          pipId: z
            .union([
              z.string().describe("PI planning user id, null when the user is not mapped"),
              z.null().describe("PI planning user id, null when the user is not mapped"),
            ])
            .describe("PI planning user id, null when the user is not mapped"),
          almId: z
            .union([
              z.string().describe("ALM user id, null when the user is not a mapped ALM user"),
              z.null().describe("ALM user id, null when the user is not a mapped ALM user"),
            ])
            .describe("ALM user id, null when the user is not a mapped ALM user"),
        }),
        z.null(),
      ])
      .optional(),
    stepValue: z
      .union([
        z
          .number()
          .int()
          .describe(
            "Id of the sticky's step estimate, one of the type's step_estimate_values; null when it has none",
          ),
        z
          .null()
          .describe(
            "Id of the sticky's step estimate, one of the type's step_estimate_values; null when it has none",
          ),
      ])
      .describe(
        "Id of the sticky's step estimate, one of the type's step_estimate_values; null when it has none",
      )
      .optional(),
    templateId: z.string().optional(),
    isOrigin: z.boolean().optional(),
    linkedStickies: z
      .array(
        z.object({ linkId: z.string(), stickyId: z.string(), direction: z.enum(["from", "to"]) }),
      )
      .optional(),
    statusDistribution: z
      .union([
        z
          .record(z.string(), z.object({ points: z.number(), value: z.number().int() }))
          .describe("Progress of the linked child stickies by status class"),
        z.null(),
      ])
      .optional(),
    statusDistributionState: z
      .union([
        z
          .enum(["ready", "pending", "unavailable"])
          .describe(
            "ready: the graph result is present. pending: the graph is still being built; the result will follow. unavailable: the graph could not be read.",
          ),
        z.null(),
      ])
      .optional(),
  })
  .describe("Update payload: a missing key leaves the field unchanged.");
export const stickyUpdatedEventSchema = z
  .object({
    id: z.string().optional(),
    almIssueId: z.union([z.number().int(), z.string()]).optional(),
    boardId: z.string().optional(),
    WSJFValue: z.union([z.number(), z.null()]).optional(),
    almIssueUrl: z.string().optional(),
    stackPos: z.number().int().optional(),
    text: z.string().optional(),
    typeId: z.string().optional(),
    statusClass: z.enum(["todo", "in-progress", "done", "undefined"]).optional(),
    status: z.string().optional(),
    aCenter: z.tuple([z.number(), z.number()]).optional(),
    teamId: z.union([z.number().int(), z.null()]).optional(),
    iterationNumber: z.union([z.number().int(), z.null()]).optional(),
    almSource: z.union([z.number().int(), z.string(), z.null()]).optional(),
    storyPoints: z.union([z.number(), z.null()]).optional(),
    risk: z.enum(["R", "O", "A", "M", ""]).optional(),
    dependTeamId: z.union([z.number().int(), z.null()]).optional(),
    dependTeam: z.union([z.string(), z.null()]).optional(),
    objectives: z.array(z.object({ id: z.string(), boardId: z.string() })).optional(),
    precondTeamId: z.number().int().optional(),
    precondTeam: z.string().optional(),
    flagType: z.union([z.string(), z.null()]).optional(),
    stickyGroup: z.union([z.string(), z.null()]).optional(),
    artId: z.union([z.number().int(), z.null()]).optional(),
    transition: z.string().optional(),
    reactions: z.record(z.string(), z.array(z.string())).optional(),
    assignee: z
      .union([
        z.object({
          pipId: z
            .union([
              z.string().describe("PI planning user id, null when the user is not mapped"),
              z.null().describe("PI planning user id, null when the user is not mapped"),
            ])
            .describe("PI planning user id, null when the user is not mapped"),
          almId: z
            .union([
              z.string().describe("ALM user id, null when the user is not a mapped ALM user"),
              z.null().describe("ALM user id, null when the user is not a mapped ALM user"),
            ])
            .describe("ALM user id, null when the user is not a mapped ALM user"),
        }),
        z.null(),
      ])
      .optional(),
    reporter: z
      .union([
        z.object({
          pipId: z
            .union([
              z.string().describe("PI planning user id, null when the user is not mapped"),
              z.null().describe("PI planning user id, null when the user is not mapped"),
            ])
            .describe("PI planning user id, null when the user is not mapped"),
          almId: z
            .union([
              z.string().describe("ALM user id, null when the user is not a mapped ALM user"),
              z.null().describe("ALM user id, null when the user is not a mapped ALM user"),
            ])
            .describe("ALM user id, null when the user is not a mapped ALM user"),
        }),
        z.null(),
      ])
      .optional(),
    stepValue: z
      .union([
        z
          .number()
          .int()
          .describe(
            "Id of the sticky's step estimate, one of the type's step_estimate_values; null when it has none",
          ),
        z
          .null()
          .describe(
            "Id of the sticky's step estimate, one of the type's step_estimate_values; null when it has none",
          ),
      ])
      .describe(
        "Id of the sticky's step estimate, one of the type's step_estimate_values; null when it has none",
      )
      .optional(),
    templateId: z.string().optional(),
    isOrigin: z.boolean().optional(),
    linkedStickies: z
      .array(
        z.object({ linkId: z.string(), stickyId: z.string(), direction: z.enum(["from", "to"]) }),
      )
      .optional(),
    statusDistribution: z
      .union([
        z
          .record(z.string(), z.object({ points: z.number(), value: z.number().int() }))
          .describe("Progress of the linked child stickies by status class"),
        z.null(),
      ])
      .optional(),
    statusDistributionState: z
      .union([
        z
          .enum(["ready", "pending", "unavailable"])
          .describe(
            "ready: the graph result is present. pending: the graph is still being built; the result will follow. unavailable: the graph could not be read.",
          ),
        z.null(),
      ])
      .optional(),
  })
  .describe("Update payload: a missing key leaves the field unchanged.");
export const topStickyEventSchema = z.array(z.string());
